import React from 'react';
import { Sparkles } from 'lucide-react';

const Header = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-blue-100">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_cisto-i-fino/artifacts/qme8j9z0_ChatGPT%20Image%2013%20feb.%202026%2018_35_50.png" 
              alt="Čisto i Fino Logo"
              className="h-24 w-auto object-contain"
            />
            <div className="flex flex-col">
              <h1 className="!font-bold !text-xl !text-left text-blue-900 leading-tight">Servis za čišćenje</h1>
              <h1 className="!font-bold !text-xl !text-left text-blue-900 leading-tight">Čisto i Fino</h1>
            </div>
          </div>
          
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')}
            className="text-gray-700 hover:text-blue-600 font-medium transition-colors">

              Usluge
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors">

              Kontakt
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-blue-700 transition-colors">

              Dobij Ponudu
            </button>
          </nav>

          <button
            onClick={() => scrollToSection('contact')}
            className="md:hidden bg-blue-600 text-white px-5 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors text-sm">

            Kontakt
          </button>
        </div>
      </div>
    </header>);

};

export default Header;